import React from 'react';
import {
  AccordionSummary as MaterialAccordionSummary,
  AccordionSummaryProps as MaterialAccordionSummaryProps,
} from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  accordionSummaryIcon: {
    transform: 'rotate(90deg)',
  },
}));

interface AccordionSummaryProps extends MaterialAccordionSummaryProps {}

export const AccordionSummary = ({ ...rest }: AccordionSummaryProps) => {
  const { classes } = useStyles();
  return (
    <MaterialAccordionSummary
      expandIcon={<ChevronRight className={classes.accordionSummaryIcon} />}
      {...rest}
    />
  );
};
